import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import { partnersApi } from '@src/features/users/services/partners-api';
import { entityFilterIds } from '../../helpers/filter-none';

const PartnerFilterValue = ({ id }: { id: string | number }) => {
  const { data: partner } = partnersApi.useFetchOne({ id });

  return (
    <Avatar className='size-6 border-2 border-white'>
      <AvatarImage src={partner?.avatar} />
      <AvatarFallback colorId={partner?.id as number}>
        {partner?.company_name?.[0]}
      </AvatarFallback>
    </Avatar>
  );
};

export function PartnerFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return (
    <div className='-space-x-2 flex items-center'>
      {entityFilterIds(filter.value).map((val) => (
        <PartnerFilterValue
          key={val}
          id={val}
        />
      ))}
    </div>
  );
}
